export { View as FixedScreenV2 } from './view'
